

export const routes = {
    root: '/',
    hoursandlocation: '/hours-location',
    machines: '/machines-prices',
    privacypolicy: '/privacypolicy',
    termsofuse: '/termsofuse',
}